module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_tomelilla-078a2645800337583a32d898fadacec8.png";